export const sortByTitleToNumber: Record<string, number> = {
    'top & trending': 0,
    latest: 1,
    search: 2,
};
